import {
  SET_PACKAGE_IDS,
  SET_ADDITIONAL_SERVICES,
  SET_UNSELECTED_PACKAGE_SERVICES,
  SET_UNSELECTED_ADDITIONAL_INFO,
  SET_OPTIONAL_ADDITIONAL_INFO,
  SET_UNSELECTED_MEDICAL_INFO,
  SET_OPTIONAL_MEDICAL_INFO,
  SET_POST_PACKAGE_IDS,
  SET_POST_ADDITIONAL_SERVICES,
  SET_POST_OPTIONAL_ADDITIONAL_INFO,
  SET_POST_OPTIONAL_MEDICAL_INFO,
  SET_POST_UNSELECTED_ADDITIONAL_INFO,
  SET_POST_UNSELECTED_MEDICAL_INFO,
  SET_POST_UNSELECTED_PACKAGE_SERVICES
} from "../../actions/partner-admission"

const initialState = {
  packageIds: [],
  additionalServices: [],
  unSelectedPackageServices: [],
  unSelectedAdditionalInfo: [],
  optionalAdditionalInfo: [],
  unSelectedMedicalInfo: [],
  optionalMedicalInfo: [],
  postPackageIds: null,
  postAdditionalServices: null,
  postOptionalAdditionalInfo: null,
  postOptionalMedicalInfo: null,
  postUnselectedAdditionalInfo: null,
  postUnselectedMedicalInfo: null,
  postUnselectedPackageServices: null
}

const packageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PACKAGE_IDS:
      return { ...state, packageIds: action.payload }
    case SET_ADDITIONAL_SERVICES:
      return { ...state, additionalServices: action.payload }
    case SET_UNSELECTED_PACKAGE_SERVICES:
      return { ...state, unSelectedPackageServices: action.payload }
    case SET_UNSELECTED_ADDITIONAL_INFO:
      return { ...state, unSelectedAdditionalInfo: action.payload }
    case SET_OPTIONAL_ADDITIONAL_INFO:
      return { ...state, optionalAdditionalInfo: action.payload }
    case SET_UNSELECTED_MEDICAL_INFO:
      return { ...state, unSelectedMedicalInfo: action.payload }
    case SET_OPTIONAL_MEDICAL_INFO:
      return { ...state, optionalMedicalInfo: action.payload }
    case SET_POST_PACKAGE_IDS:
      return { ...state, postPackageIds: action.payload }
    case SET_POST_ADDITIONAL_SERVICES:
      return { ...state, postAdditionalServices: action.payload }
    case SET_POST_OPTIONAL_ADDITIONAL_INFO:
      return { ...state, postOptionalAdditionalInfo: action.payload }
    case SET_POST_OPTIONAL_MEDICAL_INFO:
      return { ...state, postOptionalMedicalInfo: action.payload }
    case SET_POST_UNSELECTED_ADDITIONAL_INFO:
      return { ...state, postUnselectedAdditionalInfo: action.payload }
    case SET_POST_UNSELECTED_MEDICAL_INFO:
      return { ...state, postUnselectedMedicalInfo: action.payload }
    case SET_POST_UNSELECTED_PACKAGE_SERVICES:
      return { ...state, postUnselectedPackageServices: action.payload }
    default:
      return state
  }
}

export default packageReducer
